const RECURRING_LIMIT_IN_YEARS = 5

export default RECURRING_LIMIT_IN_YEARS
